import React from "react";
import { useParams } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";
import TicketsManagerTabs from "../../components/TicketsManagerTabs";
import Ticket from "../../components/Ticket";

import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
	chatContainer: {
		flex: 1,
		padding: "2px",
		height: `calc(100% - 48px)`,
		overflowY: "hidden",
	},
	chatPapper: {
		display: "flex",
		height: "100%",
	},
	contactsWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflowY: "hidden",
		position: "relative",
		// Larguras fixas baseadas no tamanho da tela
		width: "420px", // Desktop padrão
		flexShrink: 0,

		// Telas grandes (>1600px) - pode ser um pouco maior
		[theme.breakpoints.up(1600)]: {
			width: "450px",
		},

		// Telas médias (1200-1600px)
		[theme.breakpoints.between(1200, 1600)]: {
			width: "380px",
		},

		// Telas pequenas como laptops 13" (1000-1200px)
		[theme.breakpoints.between(1000, 1200)]: {
			width: "320px",
		},

		// Telas muito pequenas como laptops 11" (≤1000px)
		[theme.breakpoints.down(1000)]: {
			width: "280px", // Bem estreita para dar espaço ao ContactDrawer
		},

		// Tablets
		[theme.breakpoints.down('md')]: {
			width: "300px",
		},

		// Mobile
		[theme.breakpoints.down('sm')]: {
			width: "100%",
		},
	},
	messagesWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		flexGrow: 1,
	},
	welcomeMsg: {
		background: theme.palette.tabHeaderBackground,
		display: "flex",
		justifyContent: "space-evenly",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
	},
	logo: {
		logo: theme.logo,
		content: "url(" + (theme.mode === "light"
			? theme.calculatedLogoLight()
			: theme.calculatedLogoDark()) + ")",
		maxWidth: "100%",
		height: "auto"
	},
}));

const TicketsCustom = () => {
	const classes = useStyles();
	const { ticketId } = useParams();

	return (
		<QueueSelectedProvider>
			<div className={classes.chatContainer}>
				<div className={classes.chatPapper}>
					<div className={classes.contactsWrapper}>
						<TicketsManagerTabs />
					</div>
					<div className={classes.messagesWrapper}>
						{ticketId ? (
							<Ticket />
						) : (
							<Hidden only={["sm", "xs"]}>
								<Paper square variant="outlined" className={classes.welcomeMsg}>
									<span>
										<center>
											<img className={classes.logo} width="50%" alt="" />
										</center>
										{i18n.t("chat.noTicketMessage")}
									</span>
								</Paper>
							</Hidden>
						)}
					</div>
				</div>
			</div>
		</QueueSelectedProvider>
	);
};

export default TicketsCustom;